/* Publish by EComposer at 2024-06-20 08:30:42*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-luxwxq15s6r"]=  window.__ectimmers["ecom-luxwxq15s6r"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-luxwxq15s6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-luxwxq15s6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2hiseaayqsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hiseaayqsb', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}